export const LocalStorageStorage = () => {
    const get = key => {
        const value = localStorage.getItem(key);

        return value ? JSON.parse(value) : value;
    };
    const remove = key => {
        localStorage.removeItem(key);
    };
    const set = (key, value) => {
        const stringyfiedValue = JSON.stringify(value);
        localStorage.setItem(key, stringyfiedValue);
    };

    return {
        get,
        remove,
        set,
    };
};
